import {
    createObservableDataAction,
    IAction,
    ICreateActionContext,
    IActionContext,
    CacheType,
    IActionInput
} from '@msdyn365-commerce/core';
import { ProductDimension, retailAction } from '@msdyn365-commerce/retail-proxy';
import { getSelectedProductIdFromActionInput, getSelectedVariant, SelectedVariantInput } from '@msdyn365-commerce-modules/retail-actions';
import { getWhatisinBoxInput, IWhatisinBox } from './product-services';

/**
 * GetProductInfoInput
 */
class GetWhatisinBoxInput implements IActionInput {
    public readonly selectedVariantInput: SelectedVariantInput;

    constructor(productId: number, channelId: number, matchingDimensionValues?: ProductDimension[]) {
        this.selectedVariantInput = new SelectedVariantInput(productId, channelId, matchingDimensionValues);
    }

    public getCacheKey = () => this.selectedVariantInput.getCacheKey();
    public getCacheObjectType = () => 'HEI-WhatisinBox';
    public dataCacheType = (): CacheType => this.selectedVariantInput.dataCacheType();
}

async function action(input: GetWhatisinBoxInput, ctx: IActionContext): Promise<IWhatisinBox> {
    const product = await getSelectedVariant(input.selectedVariantInput, ctx);
    const itemId = product?.ItemId;

    if (!itemId) {
        throw new Error('Unable to get product SKU');
    }

    const WhatisinBoxInput = getWhatisinBoxInput(itemId);
    return retailAction(WhatisinBoxInput, ctx);
}

/**
 * Get Warranty Info Data Action
 */
export default createObservableDataAction({
    action: <IAction<IWhatisinBox>>action,
    input: (context: ICreateActionContext) => {
        const productId = getSelectedProductIdFromActionInput(context);
        if (productId) {
            return new GetWhatisinBoxInput(+productId, +context.requestContext.apiSettings.channelId, []);
        } else {
            throw new Error('Unable to create GetWhatisinBoxInput, no productId found on module config or query');
        }
    }
});
